import AioExpressionParsingException from '../exception/AioExpressionParsingException.js';
/**
 * Custom error listener for handling syntax errors in the Aio expression parsing.
 */
export default class CustomErrorListener {
    /**
     * Handles syntax errors by throwing an AioExpressionParsingException.
     *
     * @param _recognizer - The recognizer (not used).
     * @param _offendingSymbol - The offending symbol (not used).
     * @param line - The line number where the syntax error occurred.
     * @param charPositionInLine - The character position in the line where the syntax error occurred.
     * @param msg - The error message.
     * @param _e - The exception (not used).
     */
    syntaxError(_recognizer, _offendingSymbol, line, charPositionInLine, msg, _e) {
        throw new AioExpressionParsingException(`Syntax error detected: line ${line}:${charPositionInLine} ${msg}`);
    }
}
